import React, { useState, useEffect, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import Loader from "./Loader";
import moment from "moment";
import { AuthContext } from "../contexts/AuthContext";
import { AppContext } from "../contexts/AppContext";
import undrawProfile from "../img/undraw_profile.svg";
import { errorResponseMessage } from "../shared/const.prop";

const MyQueries = () => {
  const [loading, setLoading] = useState(true);
  const [queryList, setQueryList] = useState([]);
  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  useEffect(() => {
    fetchQueryList();
  }, []);

  const fetchQueryList = async () => {
    setLoading(true);
    try {
      const getQueryList = await axiosHttp.get(`my-queries`);
      if (getQueryList.status === 200) {
        let data = getQueryList?.data?.data;
        setQueryList(data);
        setLoading(false);
      }
    } catch (e) {
      //console.log(e);
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteQuery = await axiosHttp.delete(`queries/${id}`);
      if (deleteQuery.status === 200) {
        let filteredData = queryList.filter((query) => query.id !== id);
        setQueryList(filteredData);
        setLoading(false);
      }
    } catch (error) {
      //console.log(error);
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card mt-5 mb-4 query-pen-box">
      <div className="card-body p-0 px-2">
        {queryList.length === 0 && <p>No data available</p>}
        {queryList.length > 0 &&
          queryList.map((query) => {
            const { id } = query;
            return (
              <div className="row mt-2">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <div>
                    <img
                      className="img-profile rounded-circle mr-3"
                      src={query?.senderPicUrl || undrawProfile}
                      data-toggle="modal"
                      data-target="#photo"
                    />
                  </div>
                  <div>
                    {/* <a href="pending-profile.html"> */}
                    <p className="follow-name mb-0 ml-3 ">{query.senderName}</p>
                    {/* </a> */}

                    <p className="ml-3 pending-txt">
                      message: {query?.message}
                    </p>
                    <p className="ml-3 pending-txt">reply: {query?.reply}</p>
                  </div>
                  <div></div>
                  <div>
                    <p className="text-right pending-txt">
                      {moment(query?.updated_at).format("hh:mm A")}
                    </p>
                  </div>
                  <div>
                    <span onClick={() => deleteHandler(id)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M0.758057 11.2428L6.00106 5.99984L11.2441 11.2428M11.2441 0.756836L6.00006 5.99984L0.758057 0.756836"
                          stroke="black"
                          strokeOpacity="0.5"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MyQueries;
